import { OperationVariables } from "@apollo/client";
import { LayoutNodeFilter } from "@towersystems/roam-common/lib/generated-types";
import { LayoutNodeFilterType } from "@towersystems/roam-common/lib/generated-types";
import { Product } from "@towersystems/roam-common/lib/generated-types";
import { minBy } from "lodash";
import ProductModel from "../data/model/Product";

export const lowestPrice = <T extends Product | ProductModel>(
  product: T,
  variants: T[] = []
): number => {
  const allLocationInventoryPricing = [
    ...(product.locationInventoryPricing || []),
    ...variants.flatMap((v) => v.locationInventoryPricing),
  ];

  return minBy(allLocationInventoryPricing.map((i) => i.retailPrice)) || 0;
};

export function graphqlVariableFormatter(
  variables: OperationVariables,
  filter?: LayoutNodeFilter
) {
  const extraFilters = filter
    ? {
        [filterTypeToProductFilterMap[filter.type]]: {
          in: filter.values,
        },
      }
    : {};

  return {
    options: {
      ...variables,
      filter: {
        ...variables.filter,
        ...extraFilters,
      },
    },
  };
}

export const filterTypeToProductFilterMap = {
  [LayoutNodeFilterType.CATEGORY]: "categoryId",
  [LayoutNodeFilterType.DEPARTMENT]: "departmentId",
};

